import { maxLength, required } from 'utils/validation'
import { get } from 'lodash'

const validate = (values, props) => {
  const isPersonalReflectionMandatory = get(props, 'isPersonalReflectionMandatory')

  return {
    personalReflection: (isPersonalReflectionMandatory && required((get(values, 'personalReflection')))) || maxLength(2000)(get(values, 'personalReflection')),
  }
}

export default validate
